import javaScriptIcon from "./assets/javascript.svg";
import reactIcon from "./assets/react.svg";
import cssIcon from "./assets/css3.svg";
import htmlIcon from "./assets/html.svg";
import vsCodeIcon from "./assets/vscode.svg";
import githubIcon from "./assets/github.svg";
import commandLineIcon from "./assets/command-line.svg";
import responsiveIcon from "./assets/responsive.svg";
import chromeIcon from "./assets/chrome.svg";
import npmIcon from "./assets/npm.svg";
import tailwindIcon from "./assets/tailwind.svg";
import canvasIcon from "./assets/canvas.svg";

const skillsData = [
  {
    skill: "JavaScript",
    image: javaScriptIcon,
  },
  {
    skill: "React",
    image: reactIcon,
  },
  {
    skill: "CSS3",
    image: cssIcon,
  },
  {
    skill: "HTML5",
    image: htmlIcon,
  },
  {
    skill: "VS Code",
    image: vsCodeIcon,
  },
  {
    skill: "Github",
    image: githubIcon,
  },
  {
    skill: "Responsive Design",
    image: responsiveIcon,
  },
  {
    skill: "Chrome Dev Tools",
    image: chromeIcon,
  },
  {
    skill: "Tailwind",
    image: tailwindIcon,
  },
  {
    skill: "NPM",
    image: npmIcon,
  },
];

export default skillsData;
